import React, { createContext, useContext, useState, useEffect } from "react";
import hr from "../translations/hr";
import en from "../translations/en";
import zh from "../translations/zh";

const dictionaries = { hr, en, zh };

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    const saved = localStorage.getItem("lipik_language");
    if (saved && ["hr", "en", "zh"].includes(saved)) {
      return saved;
    }
    // Hrvatski je uvijek prvi i glavni zadani jezik
    return "hr";
  });

  const [aiBannerDismissed, setAiBannerDismissed] = useState(() => {
    return localStorage.getItem("lipik_ai_banner_dismissed") === "true";
  });

  useEffect(() => {
    localStorage.setItem("lipik_language", language);
    document.documentElement.lang = language === "zh" ? "zh-CN" : language;
  }, [language]);

  const setLanguage = (lang) => {
    if (["hr", "en", "zh"].includes(lang)) {
      setLanguageState(lang);
      // Reset banner dismissal so user sees notice when switching to a translated language
      setAiBannerDismissed(false);
      localStorage.removeItem("lipik_ai_banner_dismissed");
    }
  };

  const dismissAiBanner = () => {
    setAiBannerDismissed(true);
    localStorage.setItem("lipik_ai_banner_dismissed", "true");
  };

  // Helper function to resolve dot-notated paths like t('nav.home')
  const t = (path) => {
    const currentDict = dictionaries[language] || dictionaries.hr;
    const fallbackDict = dictionaries.hr;

    const resolve = (obj, p) => {
      return p.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : null), obj);
    };

    const val = resolve(currentDict, path);
    if (val !== null && val !== undefined) return val;

    const fallbackVal = resolve(fallbackDict, path);
    if (fallbackVal !== null && fallbackVal !== undefined) return fallbackVal;

    return path;
  };

  const currentDict = dictionaries[language] || dictionaries.hr;

  return (
    <LanguageContext.Provider
      value={{
        language,
        setLanguage,
        t,
        translations: currentDict,
        isAiTranslated: language === "en" || language === "zh",
        aiBannerDismissed,
        dismissAiBanner,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export default LanguageContext;
